import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

const PipelinesWorkspaceVariablesPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./variables'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesWorkspaceVariablesPageLoadable;
